import clsx from 'clsx';
import type { MagazineFaqBulletProps } from './interfaces';
import styles from './MagazineFaqBullet.module.scss';

const MagazineFaqBullet = ({
  isActive,
  onClick,
  className,
  ...props
}: MagazineFaqBulletProps) => {
  return (
    <button
      onClick={onClick}
      className={clsx(
        styles.base,
        { [styles.selectedBullet]: isActive },
        className
      )}
      {...props}
    />
  );
};

export default MagazineFaqBullet;
